export interface InsightsNavItem {
  label: string;
  route: string;
  exact?: boolean;
  activePrefixes?: string[];
}

export const insightsNavItems: InsightsNavItem[] = [
  { label: 'Brand Insights', route: '/insights/brand', activePrefixes: ['/insights/brand'] },
  { label: 'Agency Insights', route: '/insights/agency', activePrefixes: ['/insights/agency'] },
  { label: 'Creator Insights', route: '/insights/creator', activePrefixes: ['/insights/creator'] },
  { label: 'Brief Insights', route: '/insights/brief', activePrefixes: ['/insights/brief'] },
  {
    label: 'Video Mod. Insights',
    route: '/insights/video-moderation',
    activePrefixes: ['/insights/video-moderation'],
  },
];

export function isInsightsNavItemActive(item: InsightsNavItem, url: string): boolean {
  const path = url.split('?')[0] ?? url;

  if (item.exact) {
    return path === item.route || path === `${item.route}/`;
  }

  const prefixes = item.activePrefixes ?? [item.route];
  return prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export type CreatorInsightsSection =
  | 'profile'
  | 'activities'
  | 'socials'
  | 'payouts'
  | 'media-kit'
  | 'payment-details';

export interface CreatorInsightsNavItem {
  label: string;
  section: CreatorInsightsSection;
  requiresShoutHandle?: boolean;
}

export const creatorInsightsNavItems: CreatorInsightsNavItem[] = [
  { label: 'Profile', section: 'profile' },
  { label: 'Activities', section: 'activities' },
  { label: 'Socials', section: 'socials' },
  { label: 'Payouts', section: 'payouts' },
  { label: 'Media Kit', section: 'media-kit', requiresShoutHandle: true },
  { label: 'Payment Details', section: 'payment-details' },
];

export type BriefInsightsSection = 'details' | 'applications';

export interface BriefInsightsNavItem {
  label: string;
  section: BriefInsightsSection;
}

export const briefInsightsNavItems: BriefInsightsNavItem[] = [
  { label: 'Brief', section: 'details' },
  { label: 'Applications', section: 'applications' },
];

export type BrandInsightsSection =
  | 'profile'
  | 'billing'
  | 'team'
  | 'visits'
  | 'pricing_models'
  | 'affiliate'
  | 'appless';

export interface BrandInsightsNavItem {
  label: string;
  section: BrandInsightsSection;
}

export const brandInsightsNavItems: BrandInsightsNavItem[] = [
  { label: 'Profile', section: 'profile' },
  { label: 'Billing', section: 'billing' },
  { label: 'Team', section: 'team' },
  { label: 'Visits', section: 'visits' },
  { label: 'Pricing Models', section: 'pricing_models' },
  { label: 'Affiliate', section: 'affiliate' },
  { label: 'Appless', section: 'appless' },
];
